export default "__VITE_ASSET__DKsKgjuI__"